import { takeLatest } from "redux-saga/effects";
import { CHECK_LOGIN, LOGOUT } from "../actions/Authentication/types";
import { getRequest, showError } from "../components/commonUtilities";
import axios from "axios";
import { MixPanel } from "../MixPanel";
import { ACCESS_TOKEN } from "../constants";
import { ReactGa } from "GoogleAnalytics";

// NOTE: logout() should never be dispatched in iframe context.
// All callers (idle-session-timeout, refresh-token recursion guard, nav button)
// are already guarded with isIframeView checks that prevent dispatching LOGOUT.
function* logout() {
    const afterLogout = () => {
        MixPanel.reset();
        ReactGa.reset();
        localStorage.setItem("termsAndConditionsAgreed", "false");

        // removing the accessToken because we are logging out the user
        localStorage.removeItem(ACCESS_TOKEN);

        window.location.href = "/loginpage/";
    };

    try {
        yield axios.get("/api/logout/").then((response) => {
            const { status } = response;
            if (response && (status === 302 || status === 403 || status === 200)) {
                afterLogout();
            }
        });
    } catch (err) {
        const { response } = err as {
            response: {
                data: {
                    name: string;
                };
                status: number;
            };
        };

        const { status } = response;

        // Hack for status code 403 need to find the actual issue why browser is sending get request
        if (response && (status === 302 || status === 403)) {
            afterLogout();
        } else {
            showError(err);
        }
    }
}

export function* logoutSaga() {
    yield takeLatest(LOGOUT, logout);
}

function* checkLogin() {
    try {
        yield getRequest("/api/checklogin/");
    } catch (err) {
        const { response } = err as {
            response: {
                data: {
                    name: string;
                };
                status: number;
            };
        };

        const { status } = response;

        if (response && status === 403) {
            window.location.href = "/loginpage/";
        } else if (status === 200) {
            window.location.href = "/";
        } else {
            showError(err);
        }
    }
}

export function* checkLoginSaga() {
    yield takeLatest(CHECK_LOGIN, checkLogin);
}
